import { render, staticRenderFns } from "./motor.vue?vue&type=template&id=1e05d764&scoped=true"
import script from "./motor.vue?vue&type=script&lang=js"
export * from "./motor.vue?vue&type=script&lang=js"
import style0 from "./motor.vue?vue&type=style&index=0&id=1e05d764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05d764",
  null
  
)

export default component.exports